import { style } from 'typestyle'
export const mr24 = style({ marginRight: '24px' })
